/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
import PromotionGroupMasterContent from './PromotionGroupMasterContent'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeletePromotionGroupDetails, PromotionGroupDetailsGetData, SavePromotionGroupDetails, SavePromotionGroupListDetails } from './PromotionGroupController'

const PromotionGroupMaster = (props) => {

    let history = useHistory();

    //*** User input related states */
    const [strPromoGrp, SetCode] = useState("");// Set Code
    const [strPromoGrpDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [OUTLET, SetOutlet] = useState(false)
    const [PAYACT, SetPayAct] = useState(false)
    const [EXCLACT, SetExclAct] = useState(false)
    const [INCLACT, SetInclAct] = useState(false)
    const [PSKBUID, SetPSKBUID] = useState(false)
    const [GRPBID, SetGRPBID] = useState(false)
    const [DISKPER, SetDISKPER] = useState(false)
    const [DISKAMT, SetDISKAMT] = useState(false)
    const [FSKUBID, SetFSKUBID] = useState(false)
    const [TICKET, SetTICKET] = useState(false)
    const [TICKETVALUE, SetTICKETVALUE] = useState(0)
    const [VOUACT, SetVOUACT] = useState(false)
    const [POINTS, SetPOINTS] = useState(false)
    const [CUSTOMERSPECIFIC, SetCUSTOMERSPECIFIC] = useState(false)
    const [CARD, SetCARD] = useState(false)
    const [ExcludeGroup1, SetExcludeGroup1] = useState(1)
    const [ExcludeGroup2, SetExcludeGroup2] = useState(1)
    const [IncludeGroup1, SetIncludeGroup1] = useState(1)
    const [IncludeGroup2, SetIncludeGroup2] = useState(1)
    const [CouponRedemption, SetCouponRedemption] = useState(false)
    const [ExcludeInclusiveItem, SetExcludeInclusiveItem] = useState(false)
    const [ValidQtyCheckSKU, SetValidQtyCheckSKU] = useState(false)
    const [DiscAmtApplyToBill, SetDiscAmtApplyToBill] = useState(false)
    const [pricemode, SetPricemode] = useState(false)
    const [comboType, SetComboType] = useState(false)
    const [valueCheckForBill, setValueCheckForBill] = useState(false)
    const [valueCheckForOfferItems, setValueCheckForOfferItems] = useState(false)
    const [intStockCodeWise, setintStockCodeWise] = useState(false)

    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false) //nullcode true means it is not a auto generated code
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    var time = process.env.REACT_APP_ALERTTIMEOUT

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);
    //import from contexts

    //**Get File Details */
    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)
        const ApiURL = window.Links.ApiURL


        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }, [strPromoGrp])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])



    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };

    async function getData(searchData) {

        if (searchData == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const { success, data } = await PromotionGroupDetailsGetData(searchData);

        SetLoadingAlert(false)

        if (success) {

            setSearchdisabled(true)
            SetDescription(data.description)
            SetActive(data.status)
            SetOutlet(data.outlet)
            SetPayAct(data.payement)
            SetExclAct(data.exclusion)
            SetInclAct(data.includes)
            SetPSKBUID(data.skuBundle)
            SetGRPBID(data.groupBundle)
            SetDISKPER(data.discountPre)
            SetDISKAMT(data.discountAmo)
            SetFSKUBID(data.free)
            SetTICKET(data.ticket)
            SetTICKETVALUE(data.ticketValue)
            SetVOUACT(data.voucher)
            SetPOINTS(data.point)
            SetCARD(data.intCard)
            SetCUSTOMERSPECIFIC(data.cusSpecific)
            SetIncludeGroup1(data.intIncQty == 1 ? 1 : data.intIncValue == 1 ? 2 : 0)
            SetExcludeGroup1(data.intExcQty == 1 ? 1 : data.intExcValue == 1 ? 2 : 0)
            SetExcludeGroup2(data.intExcItem == 1 ? 1 : data.intExcCombination == 1 ? 2 : 0)
            SetIncludeGroup2(data.intIncItem == 1 ? 1 : data.intIncCombination == 1 ? 2 : 0)
            SetCouponRedemption(data.intCouponRedemption)
            SetExcludeInclusiveItem(data.intExcludeInclusiveItem)
            SetValidQtyCheckSKU(data.intValidQtyCheckSKU)
            SetDiscAmtApplyToBill(data.intDiscAmtApplyToBill)
            SetPricemode(data.intPricemode)
            SetComboType(data.intComboType)
            setValueCheckForBill(data.intValueCheckForBill)
            setValueCheckForOfferItems(data.intValueCheckForOfferItems)
            setintStockCodeWise(data.intStockCodeWise)
            setCrBy(data.createBy)
            setCrDate(data.createDate)
            setMdBy(data.modifyBy)
            setMdDate(data.modifyDate == "1900-01-01T00:00:00" ? "" : data.modifyDate)
            setCrEnable(true)

            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            SetAddNew(false)
            SetDeleteEnable(true)

            setReason("Updated")
            SetEditEnable(true)

        } else if (result.success == false) {
            if (nullCode == false) {
                setDisabledCode(true)
                displayAlertMessage('success', "Record Not Found !")
                SetCode("")
            }
        }
    }

    //*** End useEffect */


    // print Function
    async function handlePrint(option) {
        const authToken = localStorage.getItem("authToken")
        var option = option

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/PromotionGroup/report/${LogUserType}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {

                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function stringToBool(value) {
        value = value.toString().toLowerCase();
        return value === "1" || value === "true"

    }

    //save button function
    const handlesave = async (e) => {
        var ExcelItemsRows = [...Excelitems]
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
            var saveList = []
            ExcelItemsRows.map(async (localState) => {
                if ((localState.Code != null) && (localState.Description != null) && (localState.Active != null) || !localState.Active) {
                    saveList.push({
                        DesignationCode: localState.Code,
                        DesignationName: localState.Description,
                        IsActive: stringToBool(localState.Active),
                    })
                }
            })

            const promotionGroupArray = {
                PromotionGroupList: saveList,
                User: LogUserType,
                MenuCode: menuCode,
                LoggedCompany: LogCompanyCode,
                LoggedLocation: LocationCode,
                Reason: Reason,
                CreateBy: LogUserType,
            }

            var response = await SavePromotionGroupListDetails(promotionGroupArray);

            if (response.success) {
                displayAlertMessage("success", response.message)

            } else {
                displayAlertMessage("danger", response.message)
            }

        } else {

            //set autogenerate code to as CODE just for display purpuse
            if (addNew == true && nullCode == false) {
                SetCode(autoCode)
            }

            if (strPromoGrp == "" && nullCode == true) {
                displayAlertMessage('danger', "Please Enter Promotion Group Code !")
                return;
            }
            if (strPromoGrpDesc == "") {
                displayAlertMessage('danger', "Please enter description")
                return;
            }

            const currentCode = addNew == true && nullCode == false ? autoCode : strPromoGrp

            if (currentCode.length == 0) {
                displayAlertMessage('danger', "Please Enter Promotion Group Code !")
                return;
            }

            //checking active sate
            const promoGroupJSON = {
                "strProCode": addNew == true && nullCode == false ? autoCode : strPromoGrp,
                "strDesc": strPromoGrpDesc,
                "intOutlet": OUTLET ? 1 : 0,
                "intPay": PAYACT ? 1 : 0,
                "intExcl": EXCLACT ? 1 : 0,
                "intIncl": INCLACT ? 1 : 0,
                "intSku": PSKBUID ? 1 : 0,
                "intGroup": GRPBID ? 1 : 0,
                "intDiscount": DISKPER ? 1 : 0,
                "intDisAmount": DISKAMT ? 1 : 0,
                "intFree": FSKUBID ? 1 : 0,
                "intTicket": TICKET ? 1 : 0,
                "intTicketValue": TICKET && TICKETVALUE ? 1 : 0,
                "intVoucher": VOUACT ? 1 : 0,
                "intPoint": POINTS ? 1 : 0,
                "intStatus": IsActive ? 1 : 0,
                "intCard": CARD ? 1 : 0,
                "intCusSpecific": CUSTOMERSPECIFIC ? 1 : 0,
                "intIncQty": INCLACT && IncludeGroup1 == 1 ? 1 : 0,
                "intIncValue": INCLACT && IncludeGroup1 == 2 ? 1 : 0,
                "intIncItem": INCLACT && IncludeGroup2 == 1 ? 1 : 0,
                "intIncCombination": INCLACT && IncludeGroup2 == 2 ? 1 : 0,
                "intExcQty": EXCLACT && ExcludeGroup1 == 1 ? 1 : 0,
                "intExcValue": EXCLACT && ExcludeGroup1 == 2 ? 1 : 0,
                "intExcItem": EXCLACT && ExcludeGroup2 == 1 ? 1 : 0,
                "intExcCombination": EXCLACT && ExcludeGroup2 == 2 ? 1 : 0,
                "intCouponRedemption": CouponRedemption ? 1 : 0,
                "intExcludeInclusiveItem": ExcludeInclusiveItem ? 1 : 0,
                "intValidQtyCheckSKU": ValidQtyCheckSKU ? 1 : 0,
                "intDiscAmtApplyToBill": DiscAmtApplyToBill ? 1 : 0,
                "intPricemode": pricemode ? 1 : 0,
                "intComboType": comboType ? 1 : 0,
                "intValueCheckForBill": valueCheckForBill ? 1 : 0,
                "intValueCheckForOfferItems": valueCheckForOfferItems ? 1 : 0,
                "intStockCodeWise": intStockCodeWise ? 1 : 0,
                "strMenuCode": menuCode,
                "strLoggedCompany": LogCompanyCode,
                "strLoggedLocation": LocationCode,
                "strReason": Reason,
                "strCreateBy": LogUserType,
                "blAddNew": addNew
            }

            //loading alert show
            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }

            //*** save/update records */
            const { success, data } = await SavePromotionGroupDetails(promoGroupJSON);

            SetLoadingAlert(false)

            if (success) {
                displayAlertMessage("success", data)
                ClearItem()
            } else {
                displayAlertMessage("danger", data)
            }
        }
    }

    //***save/update end */

    //         //notification disable function
    //         setTimeout(() => {
    //             setShow(false)
    //         }, time)
    //     }
    // }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.PG_CODE);
        getData(row.PG_CODE)
        SetDescription(row.PG_DESC);
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);

        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        SetOutlet(false)
        SetPayAct(false)
        SetExclAct(false)
        SetInclAct(false)
        SetPSKBUID(false)
        SetGRPBID(false)
        SetDISKPER(false)
        SetDISKAMT(false)
        SetFSKUBID(false)
        SetTICKET(false)
        SetTICKETVALUE(false)
        SetVOUACT(false)
        SetPOINTS(false)
        SetCUSTOMERSPECIFIC(false)
        setDisabledCode(false)
        setDisabled(false)
        // setShow(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        SetCARD(false)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        SetIncludeGroup1(1)
        SetExcludeGroup1(1)
        SetIncludeGroup2(1)
        SetExcludeGroup2(1)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        SetCouponRedemption(false)
        SetExcludeInclusiveItem(false)
        SetValidQtyCheckSKU(false)
        SetDiscAmtApplyToBill(false)
        SetPricemode(false)
        SetComboType(false)
        setCodeButton(true)
        setValueCheckForBill(false)
        setValueCheckForOfferItems(false)
        setintStockCodeWise(false)
        setExcelItems([])
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    // //********Delete button function */
    // const handleDelete = () => {
    //     const authToken = localStorage.getItem("authToken")
    //     const ApiURL = window.Links.ApiURL

    //     const rowDelete = {
    //         "strMenuCode": menuCode,
    //         "strCode": strPromoGrp,
    //         "strLoggedCompany": LogCompanyCode,
    //         "strLoggedLocation": LocationCode,
    //         "strReason": Reason,
    //         "strCreateBy": LogUserType
    //     }

    //     //loading alert show
    //     SetLoadingAlert(true)
    //     SetLoadingAlerttitle("Deleting...")

    //     fetch(`${ApiURL}Common/Delete`,
    //         {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    //             body: JSON.stringify(rowDelete)
    //         }
    //     ).then(Response => {
    //         if (Response.status == "200") {
    //             SetLoadingAlert(false)
    //             Response.json()
    //                 .then(responseData => {
    //                     console.log(responseData)
    //                     if (responseData.data == "Cannot Delete, Record Already Used!") {
    //                         setAlertMsg(responseData.data)
    //                         setAlertColor('warning')
    //                         setShow(true)
    //                     } else {
    //                         ClearItem()
    //                         setShow(true)
    //                         setAlertMsg(responseData.data)
    //                         setAlertColor('success')
    //                     }
    //                 }
    //                 )
    //         } else if (Response.status == "400") {
    //             SetLoadingAlert(false)
    //             Response.json()
    //                 .then(responseData => {
    //                     setErrorMsg(responseData.msg)
    //                 })
    //             setDisabled(false)
    //             setDisabledCode(false)
    //             setAlertColor('danger')
    //             setAlertMsg("Error !")
    //             setShow(true)
    //         } else {
    //             SetLoadingAlert(false)
    //             ClearItem()
    //         }
    //     }).catch(error => {
    //         console.log(error.message)
    //     })

    //     setTimeout(() => {
    //         setShow(false)
    //     }, time)

    // }
    // //*********Delete button function end */




    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strPromoGrp,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeletePromotionGroupDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {

            displayAlertMessage("danger", result.data)

        }
    }
    //*********Delete button function end */

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                } else {
                    setNullCode(true)
                    setAutoCode("")
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <PromotionGroupMasterContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strPromoGrp}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strPromoGrpDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    100,
                                                    true,
                                                    true,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            OUTLET={OUTLET}
                                            SetOutlet={(e) => {
                                                SetOutlet(e)
                                            }}
                                            PAYACT={PAYACT}
                                            SetPayAct={(e) => {
                                                SetPayAct(e)
                                                if (!e) {
                                                    SetCARD(false)
                                                }
                                            }}
                                            EXCLACT={EXCLACT}
                                            SetExclAct={(e) => {
                                                SetExclAct(e)
                                            }}
                                            PSKBUID={PSKBUID}
                                            SetPSKBUID={(e) => {
                                                SetPSKBUID(e)
                                            }}
                                            GRPBID={GRPBID}
                                            SetGRPBID={(e) => {
                                                SetGRPBID(e)
                                            }}
                                            DISKPER={DISKPER}
                                            SetDISKPER={(e) => {
                                                SetDISKPER(e)
                                            }}
                                            DISKAMT={DISKAMT}
                                            SetDISKAMT={(e) => {
                                                SetDISKAMT(e)
                                                if (!e) {
                                                    SetDiscAmtApplyToBill(false)
                                                }
                                            }}
                                            FSKUBID={FSKUBID}
                                            SetFSKUBID={(e) => {
                                                SetFSKUBID(e)
                                            }}
                                            TICKET={TICKET}
                                            SetTICKET={(e) => {
                                                SetTICKET(e)
                                            }}
                                            TICKETVALUE={TICKETVALUE}
                                            SetTICKETVALUE={(e) => {
                                                SetTICKETVALUE(e)
                                            }}
                                            VOUACT={VOUACT}
                                            SetVOUACT={(e) => {
                                                SetVOUACT(e)
                                            }}
                                            POINTS={POINTS}
                                            SetPOINTS={(e) => {
                                                SetPOINTS(e)
                                            }}
                                            INCLACT={INCLACT}
                                            SetInclAct={(e) => {
                                                SetInclAct(e)
                                            }}
                                            CUSTOMERSPECIFIC={CUSTOMERSPECIFIC}
                                            SetCUSTOMERSPECIFIC={(e) => {
                                                SetCUSTOMERSPECIFIC(e)
                                            }}
                                            CARD={CARD}
                                            SetCARD={(e) => {
                                                SetCARD(e)
                                            }}
                                            SetCouponRedemption={(e) => {
                                                SetCouponRedemption(e)
                                            }}
                                            CouponRedemption={CouponRedemption}

                                            SetExcludeInclusiveItem={(e) => {
                                                SetExcludeInclusiveItem(e)
                                            }}
                                            ExcludeInclusiveItem={ExcludeInclusiveItem}

                                            SetValidQtyCheckSKU={(e) => {
                                                SetValidQtyCheckSKU(e)
                                            }}
                                            ValidQtyCheckSKU={ValidQtyCheckSKU}
                                            DiscAmtApplyToBill={DiscAmtApplyToBill}
                                            SetDiscAmtApplyToBill={(e) => {
                                                SetDiscAmtApplyToBill(e)
                                            }}

                                            SetPricemode={(e) => {
                                                SetPricemode(e)
                                            }}
                                            pricemode={pricemode}

                                            SetComboType={(e) => {
                                                SetComboType(e)
                                            }}
                                            comboType={comboType}

                                            autoCode={autoCode}
                                            menuCode={menuCode}
                                            SetExcludeGroup1={SetExcludeGroup1}
                                            SetExcludeGroup2={SetExcludeGroup2}
                                            ExcludeGroup1={ExcludeGroup1}
                                            ExcludeGroup2={ExcludeGroup2}
                                            IncludeGroup1={IncludeGroup1}
                                            IncludeGroup2={IncludeGroup2}
                                            SetIncludeGroup1={SetIncludeGroup1}
                                            SetIncludeGroup2={SetIncludeGroup2}
                                            valueCheckForBill={valueCheckForBill}
                                            valueCheckForOfferItems={valueCheckForOfferItems}
                                            setValueCheckForBill={(e) => {
                                                setValueCheckForBill(e)
                                            }}
                                            setValueCheckForOfferItems={(e) => {
                                                setValueCheckForOfferItems(e)
                                            }}
                                            intStockCodeWise={intStockCodeWise}
                                            setintStockCodeWise={(e) => {
                                                setintStockCodeWise(e)
                                            }}

                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default PromotionGroupMaster